import { useMemo } from 'react';

import { DateTime } from 'luxon';
import { Col, Row } from 'react-bootstrap';
import { FaCalendarAlt } from 'react-icons/fa';
import { connectHits } from 'react-instantsearch-dom';

import TripSearchResult from './TripSearchResult';
import { TripSearchIndex } from '@website/types/TripSearchIndex';


type Props = {
  hits: TripSearchIndex[];
};

export function DepartingGroupsResultsRenderer({ hits }: Props) {
  // we group groups by date (start date)
  const groupedHits = useMemo(() => {
    return hits.reduce((acc, hit) => {
      const date = DateTime.fromISO(hit.start.utc).toISODate();

      if (acc.has(date)) {
        acc.set(date, [...(acc.get(date) ?? []), hit]);
      } else {
        acc.set(date, [hit]);
      }

      return acc;
    }, new Map<string, TripSearchIndex[]>());
  }, [hits]);

  return (
    <Row>
      <Col>
        {Array.from(groupedHits).map(([date, trips]) => (
          <Row key={date} className="border-bottom border-dark">
            <Col className="py-4">
              <h6
                className="py-2 d-flex align-items-start"
                style={{
                  gap: '0.3rem',
                }}
              >
                <FaCalendarAlt size={16} />
                <span>
                  {DateTime.fromISO(date).toLocaleString(DateTime.DATE_FULL)}
                </span>
              </h6>

              <Row>
                {trips.map((hit) => (
                  <TripSearchResult hit={hit} key={hit.objectID} type="group" />
                ))}
              </Row>
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
  );
}

const DepartingGroupsResults = connectHits(DepartingGroupsResultsRenderer);
export default DepartingGroupsResults;
